import { render } from "./FormDictItem.vue?vue&type=template&id=0b0b5d2e"
import script from "./FormDictItem.vue?vue&type=script&lang=js"
export * from "./FormDictItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__